import React, { useRef, useState } from "react";
import axios from "axios";
import "./Translate.css";
import PopupWindow from "./PopupWindow";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const Translate = () => {
  const BASEURL = {
    GET_PAGEJSON: `${apiEndpoint}/api/get-pagejson`,
    TRANSLATE_JSON: `${apiEndpoint}/api/translate-json`,
    CHECK_JOB_STATUS: `${apiEndpoint}/api/check-job-status`,
  };
  // const BASEURL = {
  //   GET_PAGEJSON: "http://localhost:8000/api/get-pagejson",
  //   TRANSLATE_JSON: "http://localhost:8000/api/translate-json",
  //   CHECK_JOB_STATUS: "http://localhost:8000/api/check-job-status",
  // };

  const [url, setUrl] = useState("");
  const [originalText, setOriginalText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [Language, setLanguage] = useState("Simplified Chinese");
  const [loading, setLoading] = useState(false); //Add loading effect.
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [BlogPromptText, setBlogPromptText] = useState("");
  const [KbPromptText, setKbPromptText] = useState("");

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSave = (newText1, newText2) => {
    setBlogPromptText(newText1);
    setKbPromptText(newText2);
    // console.log(BlogPromptText);
    // console.log(KbPromptText);
  };
  const handlePreview = async () => {
    try {
      try {
        if (!url) {
          throw new Error("URL cannot be empty. Please provide a URL.");
        }
      } catch (error) {
        console.error("Error fetching markdown:", error);
        alert(`Error: ${error.message}`);
      }
      const response = await axios.get(`${BASEURL.GET_PAGEJSON}?url=${url}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setOriginalText(response.data);
      let markdownData = response.data;
      console.log(markdownData);
      setOriginalText(JSON.stringify(markdownData, null, 2));
    } catch (error) {
      console.error("Error fetching markdown:", error);
    }
  };

  const handleTranslate = async () => {
    setLoading(true);
    console.log("Sending request: ", {
      Original: originalText,
      Language: Language,
      PromptText: BlogPromptText,
      KbPromptText: KbPromptText,
      url: url,
    });
    try {
      if (!originalText) {
        throw new Error(
          "No data retrieved. Please use Preview button retrieve the data first."
        );
      }

      const response = await axios.post(
        BASEURL.TRANSLATE_JSON,
        {
          Original: originalText,
          Language: Language,
          PromptText: BlogPromptText,
          KbPromptText: KbPromptText,
          url: url,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      pollJobStatus(response.data.job_id);
      if (response.status !== 202) {
        console.log(response);
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error translating markdown:", error);
      alert(`Error: ${error.message}`);
    }
  };
  const pollJobStatus = (jobId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(
          `${BASEURL.CHECK_JOB_STATUS}/${jobId}`
        );

        if (response.status !== 200) {
          throw new Error("Network response was not ok");
        }
        const jobStatus = response.data.status;

        if (jobStatus === "completed") {
          if (response.data.result.status_code !== 200) {
            console.log(response.data.result.message);
            throw new Error(response.data.result.message);
          }
          clearInterval(intervalId);
          setTranslatedText(JSON.stringify(response.data.result.data, null, 2));
          setLoading(false);
          console.log("Translation completed:", response.data.result);
        } else if (jobStatus === "failed") {
          clearInterval(intervalId);
          setLoading(false);
          throw new Error(response.data.message || "Translation job failed");
        }
      } catch (error) {
        clearInterval(intervalId);
        console.error("Error polling job status:", error);
        alert(`Error polling job status: ${error.message}`);
        setLoading(false);
      }
    }, 10000); // 每10秒轮询一次
  };
  const textBoxRef = useRef(null);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(translatedText);
      alert("Copied to clipboard");
    } catch (err) {
      console.error("Failed to copy：", err);
    }
  };

  const handleLanguage = (event) => {
    setLanguage(event.target.value);
    console.log(Language);
  };

  return (
    <div className="Translate">
      <header className="Translate-header"></header>
      <div className="Urls">
        {/* <input
          type="text"
          placeholder="input URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="url-input"
        />
        <button onClick={handlePreview}>Preview</button> */}
      </div>

      <div className="controls">
        <div className="control-group">
          <h3>Select Language</h3>
          <select value={Language} onChange={handleLanguage}>
            <option value="Simplified Chinese">Simplified Chinese</option>
            <option value="Japanese">Japanese</option>
            <option value="Traditional Chinese">Traditional Chinese</option>
            <option value="Arabic">Arabic</option>
            <option value="Czech">Czech</option>
            <option value="German">German</option>
            <option value="Spanish">Spanish</option>
            <option value="Finnish">Finnish</option>
            <option value="French">French</option>
            <option value="Indonesian">Indonesian</option>
            <option value="Italian">Italian</option>
            <option value="Dutch">Dutch</option>
            <option value="Norwegian">Norwegian</option>
            <option value="Polish">Polish</option>
            <option value="Portuguese">Portuguese</option>
            <option value="Romanian">Romanian</option>
            <option value="Slovak">Slovak</option>
            <option value="Swedish">Swedish</option>
            <option value="Vietnamese">Vietnamese</option>
            <option value="Korean">Korean</option>
            <option value="Russian">Russian</option>
          </select>
        </div>

        <div className="control-group">
          <h3>Translate</h3>
          <button
            onClick={handleTranslate}
            disabled={loading}
            className={loading ? "loading-button" : ""}
          >
            {loading ? "Translating..." : "Translate"}
          </button>
        </div>

        <div className="control-group">
          <h3>Copy</h3>
          <button onClick={copyToClipboard}>Copy Translation</button>
        </div>

        <div className="control-group">
          <h3>Edit Prompt</h3>
          <button onClick={openPopup}>Edit Prompt</button>
          <PopupWindow
            isOpen={isPopupOpen}
            onClose={closePopup}
            onSave={handleSave}
            initialContent1={BlogPromptText}
            initialContent2={KbPromptText}
          />
        </div>
      </div>
      <div className="text-display">
        <div className="text-section">
          <h3>Original</h3>
          <textarea
            className="text-box"
            value={originalText}
            onChange={(e) => setOriginalText(e.target.value)}
          />
        </div>
        <div className="text-section">
          <h3>Translation</h3>
          <pre className="text-box" id="Translation" ref={textBoxRef}>
            {translatedText}
          </pre>
        </div>
      </div>
      <header className="Translate-header">
        Version: {process.env.REACT_APP_COMMIT_SHA}
      </header>
    </div>
  );
};

export default Translate;
